export default {
  totalWithTaxes: {
    id: 'checkout_summary_total_with_taxes',
    defaultMessage: 'Total including taxes',
  },
  total: {
    id: 'checkout_summary_total',
    defaultMessage: 'Total',
  },
  totalDueToday: {
    id: 'checkout_price_title_due_today',
    defaultMessage: 'Total due today',
  },
}
